import styled from 'styled-components'

import theme from './atoms/theme'

const Container = styled.div`
  max-width: ${theme.layout.maxWidth};
  margin: 0 auto;
  padding: 0 2rem;
  width: 100%;
`

export const PaddedContainer = styled(Container)`
  padding-top: 8rem;
  padding-bottom: 8rem;
`

export default Container
